import eventBus from "@/app/app-event-bus.mjs";

export const EVENT_APEX_ENTER_GAME = "EVENT_APEX_ENTER_GAME";
export const EVENT_APEX_EXIT_GAME = "EVENT_APEX_EXIT_GAME";

eventBus.on(EVENT_APEX_ENTER_GAME, () => {
  // TODO(@artokun): we can add some reporting logic here later
});
